var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.operations.includes('删除'))?_c('el-button',{attrs:{"type":"primary"}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),(_vm.operations.includes('编辑'))?_c('el-button',{attrs:{"type":"primary"}},[_vm._v("编辑")]):_vm._e(),_vm._v(" "),(_vm.operations.includes('导出'))?_c('el-button',{attrs:{"type":"primary"}},[_vm._v("导出")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6bd0acc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuepage/example/operation-filter.vue
// module id = null
// module chunks = 